import { Moment } from 'moment';
import User from '@/shared/models/User';
import JobActivityCategory from '../constants/JobActivityCategory';

export default class JobActivity {
  createdOn!: Moment;
  createdBy: User | null = null;
  category = JobActivityCategory.INFO;
  code = 0;
  description = '';
}